import Component from '@glimmer/component';
import { action } from '@ember/object';
import FormField from './form-field.js';
import { useStyles } from '@frontile/theme';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';
import { a as decorateMethodV2 } from '../runtime-BPCpkOf1-DV8zmEr2.js';

class FormRadio extends Component {
  handleChange(value, event) {
    event.preventDefault();
    if (typeof this.args.onChange === 'function') {
      this.args.onChange(value, event);
    }
    if (typeof this.args._parentOnChange === 'function') {
      this.args._parentOnChange(value, event);
    }
  }
  static {
    decorateMethodV2(this.prototype, "handleChange", [action]);
  }
  get isChecked() {
    return this.args.checked == this.args.value;
  }
  get classes() {
    const {
      formRadio
    } = useStyles();
    const {
      base,
      label,
      radio,
      hint,
      labelContainer,
      inputContainer
    } = formRadio({
      size: this.args.size
    });
    let containerClasses = '';
    if (this.args.containerClass) {
      containerClasses = this.args.containerClass;
    }
    if (this.args.privateContainerClass) {
      containerClasses += ' ' + this.args.privateContainerClass;
    }
    return {
      base: base({
        class: containerClasses
      }),
      label: label(),
      inputContainer: inputContainer(),
      labelContainer: labelContainer(),
      hint: hint(),
      radio: radio()
    };
  }
  static {
    setComponentTemplate(precompileTemplate("\n    <FormField @size={{@size}} class={{this.classes.base}} as |f|>\n      <div class={{this.classes.labelContainer}}>\n        <div class={{this.classes.inputContainer}}>\n          {{!--  Zero-width space character, used to align checkbox properly --}}\n          {{!-- eslint-disable no-irregular-whitespace--}}\n          \u200B\n          <f.Radio @onChange={{this.handleChange}} @value={{@value}} @checked={{@checked}} @name={{@name}} @class={{this.classes.radio}} aria-describedby={{if @hint f.hintId}} ...attributes />\n        </div>\n\n        <f.Label @class={{this.classes.label}}>\n          {{#if (has-block)}}\n            {{yield}}\n          {{else}}\n            {{@label}}\n          {{/if}}\n        </f.Label>\n      </div>\n\n      {{#if @hint}}\n        <f.Hint @class={{this.classes.hint}}>\n          {{@hint}}\n        </f.Hint>\n      {{/if}}\n    </FormField>\n  ", {
      strictMode: true,
      scope: () => ({
        FormField
      })
    }), this);
  }
}

export { FormRadio as default };
//# sourceMappingURL=form-radio.js.map
